import React, { Component } from 'react';
import _ from 'lodash';
import Link from '../../../../../../components/ZUILib/Link';
import Image from '../../../../../../components/ZUILib/Image';
import { questionIcon, closeIcon } from '../svgIcons';
import commonUtil from '../../../../../../utils/commonUtil';
import { eventCategory } from '../../../../../../utils/clientConstant';
import WapButtomPopUp from '../../../../../../components/WapButtomPopUp/WapButtomPopUp';

const applicationRoutes = commonUtil.getApplicationRoutes();

const channel = commonUtil.getChannel();

class TodoTipoDeEventos extends Component {
  constructor(props) {
    super(props);
    this.spanRef = null;
    this.state = {
      showModalBenefits: false,
    };
  }

  setSpanRef = (element) => {
    this.spanRef = element;
  };

  handleLinkClick = () => {
    const { onLinkClick } = this.props;
    if (_.isNil(onLinkClick) || !_.isFunction(onLinkClick)) return;
    onLinkClick(eventCategory.OPENEVENT);
  };

  isVisibleTooltip = () => {
    if (this.spanRef) {
      this.spanRef.style.visibility = this.spanRef.style.visibility === 'hidden' ? 'visible' : 'hidden';
    }
  };

  toogleModalBenefits = () => {
    this.setState({ showModalBenefits: !this.state.showModalBenefits });
  };


  renderwebdata() {
    const label = this.props.labels;
    const linkForOpenEvent = {
      displayName: 'Type Event',
      route: applicationRoutes.openType,
    };
    return (
      <React.Fragment>
        <Link rrLink={linkForOpenEvent} linkJSON={{ onClickHandler: this.handleLinkClick }}>
          <div
            className="logoContentEvents"
            onClick={() =>
              this.props.handleClickMesaType(this, eventCategory.OPENEVENT)
            }
          />
        </Link>
        <h3 className="selectEvent-h3--custom">
          {commonUtil.getLabel(
            label.categoryLanding,
            'categoryLanding.open.name',
          )}
        </h3>
        <div className="characteristics">
          <p className="selectEvent-p--custom">
            {commonUtil.getLabel(
              label.categoryLanding,
              'categoryLanding.eventTypes.alloccasions',
            )}
          </p>
        </div>
      </React.Fragment>
    );
  }

  renderwapdata() {
    const labels = this.props.labels;
    const colorLink = commonUtil.getCurrentBrandColors();
    const bodyModalBenefits = commonUtil.getLabel(labels.selectMesaPage, 'selectMesaPage.openEvent.benefits');
    const titleModalBenefits = commonUtil.getLabel(labels.selectMesaPage, 'selectMesaPage.open.name');
    const linkForOpenEvent = {
      displayName: 'Type Event',
      route: applicationRoutes.openType,
    };
    const openEventSrc = [
      {
        srcSet: commonUtil.getAssetURL() + '/images/eventsActive.png',
      },
    ];
    const openEventAttr = {
      src: commonUtil.getAssetURL() + '/images/eventsActive.png',
      alt: eventCategory.OPENEVENT,
      width: 'auto',
      height: 'auto',
    };
    const celebrationList =
    `${commonUtil.getLabel(labels.categoryLanding, 'categoryLanding.eventTypes.alloccasionsWap')}`
    .split('-');
    const btnQuestion = () => {
      const btnStyles = { background: 'none', border: 'none', position: 'relative', display: 'inlineBlock' };
      const spanStyles = {
        display: 'flex',
        visibility: 'hidden',
        width: '250px',
        backgroundColor: 'rgb(255, 255, 255)',
        color: 'rgb(0, 0, 0)',
        textAlign: 'left',
        borderRadius: '6px',
        padding: '5px',
        position: 'absolute',
        zIndex: '1',
        top: '100%',
        left: '0px',
        transform: 'translateX(-50%)',
        opacity: '1',
        transition: 'opacity 0.3s',
      };
      return (
        <button
          style={btnStyles}
          onClick={this.isVisibleTooltip}
        >
          <span ref={this.setSpanRef} style={spanStyles}>
            <p style={{ maxWidth: '93%', margin: '0' }}>
              {`${commonUtil.getLabel(labels.categoryLanding, 'categoryLanding.eventTypes.othersalloccasionsWap')}`}
            </p>
            {closeIcon}
          </span>
          {questionIcon}
        </button>
      );
    };
    return (
      <React.Fragment>
        <div className="logoContent">
          <Link rrLink={linkForOpenEvent} linkJSON={{ onClickHandler: this.handleLinkClick }}>
            <Image
              imageAttr={openEventAttr}
              _imgsrc={openEventSrc}
              onClick={() =>
                this.props.handleClickMesaType(this, eventCategory.OPENEVENT)
              }
            />
          </Link>
        </div>
        <h3
          style={{
            fontSize: '15px',
            color: '#3b3b3e',
            fontWeight: 'bold',
            textAlign: 'left',
          }}
        >
          {commonUtil.getLabel(
            labels.categoryLanding,
            'categoryLanding.open.name',
          )}
        </h3>
        <div className="characteristics" style={{ color: '#5C5C5C' }}>
          <ul style={{ minHeight: '120px' }}>
            {celebrationList.map((event, index) =>
              <li key={index} style={{ display: 'flex' }}>
                {event} {celebrationList.length - 1 === index && btnQuestion()}
              </li>)
            }
          </ul>
          <button
            onClick={this.toogleModalBenefits}
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              color: `${colorLink.primary}`,
            }}
          >
            Ver beneficios
          </button>
        </div>
        { this.state.showModalBenefits &&
          <WapButtomPopUp
            handleCloseModal={this.toogleModalBenefits}
            maxHeight={500}
            modalTitle={titleModalBenefits}
          >
            <div
              style={{ textAlign: 'left', color: '#000', fontWeight: '500' }}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: bodyModalBenefits }}
            />
          </WapButtomPopUp>
        }
      </React.Fragment>
    );
  }

  render() {
    return (
      <React.Fragment>
        {channel === 'wap' ? this.renderwapdata() : this.renderwebdata()}
      </React.Fragment>
    );
  }
}

export default TodoTipoDeEventos;
